<script setup>
import { defineProps } from 'vue'
import { useI18n } from 'vue-i18n'
import Currency from '../../components/Currency.vue'

const { t } = useI18n()

defineProps({
  totalStats: {
    type: Object,
    required: true,
    default: () => ({
      totalBets: 0,
      totalWinnings: 0,
      totalLost: 0,
      activePlayers: 0
    })
  }
})
</script>

<template>
  <!-- Statistiche Rapide -->
  <v-row class="align-stretch mb-6">
    <v-col cols="12" sm="6" md="3">
      <v-card class="pa-4" color="primary" variant="tonal">
        <div class="d-flex align-center justify-space-between">
          <div>
            <p class="text-subtitle-2 text-medium-emphasis mb-1">{{ $t('dashboard.totalBets') }}</p>
            <h2 class="text-h4 font-weight-bold">{{ totalStats.totalBets.toLocaleString() }}</h2>
          </div>
          <v-icon size="40" color="primary">mdi-dice-multiple</v-icon>
        </div>
      </v-card>
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <v-card class="pa-4" color="success" variant="tonal">
        <div class="d-flex align-center justify-space-between">
          <div>
            <p class="text-subtitle-2 text-medium-emphasis mb-1">{{ $t('dashboard.totalWinnings') }}</p>
            <h2 class="text-h4 font-weight-bold">
              <Currency :amount="totalStats.totalWinnings" />
            </h2>
          </div>
          <v-icon size="40" color="success">mdi-cash-multiple</v-icon>
        </div>
      </v-card>
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <v-card class="pa-4" color="error" variant="tonal">
        <div class="d-flex align-center justify-space-between">
          <div>
            <p class="text-subtitle-2 text-medium-emphasis mb-1">{{ $t('dashboard.totalLost') }}</p>
            <h2 class="text-h4 font-weight-bold">
              <Currency :amount="totalStats.totalLost" />
            </h2>
          </div>
          <v-icon size="40" color="error">mdi-cash-remove</v-icon>
        </div>
      </v-card>
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <v-card class="pa-4" color="info" variant="tonal">
        <div class="d-flex align-center justify-space-between">
          <div>
            <p class="text-subtitle-2 text-medium-emphasis mb-1">{{ $t('dashboard.activePlayers') }}</p>
            <h2 class="text-h4 font-weight-bold">{{ totalStats.activePlayers }}</h2>
          </div>
          <v-icon size="40" color="info">mdi-account-group</v-icon>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<style scoped>
.v-card {
  transition: transform 0.2s ease-in-out;
}

.v-card:hover {
  transform: translateY(-2px);
}
</style>